import { mode } from '@chakra-ui/theme-tools';

// Menu / DropdownMenu — polished list with hover highlight and separation
export const menuStyles = {
  components: {
    Menu: {
      baseStyle: props => ({
        list: {
          bg: mode('white', 'navy.800')(props),
          borderWidth: '1px',
          borderColor: mode('gray.100', 'whiteAlpha.100')(props),
          borderRadius: 'xl', // 12px
          boxShadow: 'lg',
          py: 1,
          minW: '160px',
        },
        item: {
          fontSize: 'sm',
          fontWeight: 'medium',
          color: mode('gray.700', 'gray.300')(props),
          px: 4,
          py: '8px',
          borderRadius: 'lg',
          mx: 1,
          // Width minus the 2*mx margin
          w: 'calc(100% - 8px)',
          _hover: {
            bg: mode('brand.50', 'whiteAlpha.100')(props),
            color: mode('brand.700', 'white')(props),
          },
          _focus: {
            bg: mode('brand.50', 'whiteAlpha.100')(props),
          },
        },
        divider: {
          my: 1,
          borderColor: mode('gray.100', 'whiteAlpha.100')(props),
        },
        groupTitle: {
          fontSize: 'xs',
          fontWeight: 'semibold',
          textTransform: 'uppercase',
          letterSpacing: 'wide',
          color: mode('gray.400', 'gray.500')(props),
          px: 4,
          py: '6px',
        },
      }),
    },
  },
};
